import { useState, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

export const useAdminAuditTrail = (initialFilters = {}) => {
  const [filters, setFilters] = useState({
    action_type: '',
    log_type: '',
    admin_id: '',
    user_id: '',
    target_type: '',
    date_from: '',
    date_to: '',
    ...initialFilters
  });

  const logTypeOptions = [
    { value: '', label: 'All Logs' },
    { value: 'admin_action', label: 'Admin Actions' },
    { value: 'user_activity', label: 'User Activities' }
  ];

  const cleanFilters = useMemo(() => {
    return Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
    );
  }, [filters]);

  const queryString = new URLSearchParams(cleanFilters).toString();

  const { data: auditTrailResponse, isLoading, error } = useQuery({
    queryKey: ['adminAuditTrail', cleanFilters],
    queryFn: async () => {
      const response = await api.get(`/admin/audit-trail${queryString ? `?${queryString}` : ''}`);
      return response.data;
    }
  });

  // Fetch statistics
  const { data: statsResponse, isLoading: isLoadingStats } = useQuery({
    queryKey: ['adminAuditTrailStats'],
    queryFn: async () => {
      const response = await api.get('/admin/audit-trail/statistics');
      return response.data;
    }
  });

  const auditTrail = useMemo(() => {
    const data = auditTrailResponse?.data?.data || auditTrailResponse?.data;
    if (data && Array.isArray(data)) {
      return data;
    }
    if (data && data.data && Array.isArray(data.data)) {
      return data.data;
    }
    return [];
  }, [auditTrailResponse]);

  const statistics = useMemo(() => {
    return statsResponse?.data || {};
  }, [statsResponse]);

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSearch = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    return data.filter(log => 
      log.action_description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.ip_address?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.action_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (log.admin && (log.admin.name?.toLowerCase().includes(searchTerm.toLowerCase()) || log.admin.email?.toLowerCase().includes(searchTerm.toLowerCase()))) ||
      (log.user && (log.user.name?.toLowerCase().includes(searchTerm.toLowerCase()) || log.user.email?.toLowerCase().includes(searchTerm.toLowerCase())))
    );
  };

  const getLogTypeColor = (logType) => {
    return logType === 'admin_action' 
      ? 'bg-blue-100 text-blue-800' 
      : 'bg-purple-100 text-purple-800';
  };

  return {
    auditTrail,
    isLoading: isLoading || isLoadingStats,
    error,
    filters,
    logTypeOptions,
    handleFilterChange,
    handleSearch,
    statistics,
    getLogTypeColor
  };
};


